import httpClientSurveys from '../api/httpClientSurveys';

export const getAllSurveys = async ({ pageNumber = 1, pageSize = 10 } = {}) => {
  const response = await httpClientSurveys.get('/api/surveys/SurveyManagement/GetAll', {
    params: { pageNumber, pageSize },
  });
  return response.data;
};

export const getSurveyById = async (id) => {
  const response = await httpClientSurveys.get(`/api/surveys/SurveyManagement/GetById/${id}`);
  return response.data;
};

export const createSurvey = async (payload) => {
  const response = await httpClientSurveys.post('/api/surveys/SurveyManagement/Create', payload);
  return response.data;
};

export const updateSurvey = async (payload) => {
  const response = await httpClientSurveys.put('/api/surveys/SurveyManagement/Update', payload);
  return response.data;
};

export const deleteSurvey = async (id) => {
  const response = await httpClientSurveys.delete(`/api/surveys/SurveyManagement/Delete/${id}`);
  return response.data;
};

export const reorderSurveys = async (surveyIdsInOrder) => {
  const response = await httpClientSurveys.post('/api/surveys/SurveyManagement/Reorder', {
    surveyIdsInOrder,
  });
  return response.data;
};

export const publishSurvey = async (id, isActive) => {
  const response = await httpClientSurveys.post(`/api/surveys/SurveyManagement/Publish/${id}`, {
    isActive,
  });
  return response.data;
};

export const addQuestion = async (surveyId, payload) => {
  const response = await httpClientSurveys.post(`/api/surveys/SurveyManagement/AddQuestion/${surveyId}`, payload);
  return response.data;
};

export const updateQuestion = async (surveyId, payload) => {
  const response = await httpClientSurveys.put(`/api/surveys/SurveyManagement/UpdateQuestion/${surveyId}`, payload);
  return response.data;
};

export const removeQuestion = async (surveyId, questionId) => {
  const response = await httpClientSurveys.delete(`/api/surveys/SurveyManagement/RemoveQuestion/${surveyId}/${questionId}`);
  return response.data;
};

export const reorderQuestions = async (surveyId, questionIdsInOrder) => {
  const response = await httpClientSurveys.post(`/api/surveys/SurveyManagement/ReorderQuestions/${surveyId}`, {
    questionIdsInOrder,
  });
  return response.data;
};

export const getResponses = async (surveyId, { pageNumber = 1, pageSize = 10 } = {}) => {
  const response = await httpClientSurveys.get('/api/surveys/SurveyManagement/GetResponses', {
    params: { surveyId, pageNumber, pageSize },
  });
  return response.data;
};

export const getParticipants = async (surveyId, { pageNumber = 1, pageSize = 10 } = {}) => {
  const response = await httpClientSurveys.get('/api/surveys/SurveyManagement/GetParticipants', {
    params: { surveyId, pageNumber, pageSize },
  });
  return response.data;
};

export const getResponseSummary = async (surveyId) => {
  const response = await httpClientSurveys.get('/api/surveys/SurveyManagement/GetResponseSummary', {
    params: { surveyId },
  });
  return response.data;
};

export const getParticipantResponse = async (surveyId, personId, participantType) => {
  const response = await httpClientSurveys.get('/api/surveys/SurveyManagement/GetParticipantResponse', {
    params: { surveyId, personId, participantType },
  });
  return response.data;
};

export default {
  getAllSurveys,
  getSurveyById,
  createSurvey,
  updateSurvey,
  deleteSurvey,
  reorderSurveys,
  publishSurvey,
  addQuestion,
  updateQuestion,
  removeQuestion,
  reorderQuestions,
  getResponses,
  getParticipants,
  getResponseSummary,
  getParticipantResponse,
};

